import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "row mb-6" }
const _hoisted_11 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_12 = { class: "col-lg-8 fv-row" }
const _hoisted_13 = { class: "fv-plugins-message-container" }
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = { class: "row mb-6" }
const _hoisted_16 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_17 = { class: "col-lg-8 fv-row" }
const _hoisted_18 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_19 = { class: "row mb-6" }
const _hoisted_20 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_21 = { class: "col-lg-8 fv-row" }
const _hoisted_22 = { class: "fv-plugins-message-container" }
const _hoisted_23 = { class: "fv-help-block" }
const _hoisted_24 = { class: "row mb-6" }
const _hoisted_25 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_26 = { class: "col-lg-8 fv-row" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-10" }, null, -1)
const _hoisted_28 = { class: "row mb-5" }
const _hoisted_29 = { class: "col-md-6 fv-row" }
const _hoisted_30 = { class: "col-lg-12 col-form-label required fw-bold fs-6" }
const _hoisted_31 = ["title"]
const _hoisted_32 = { class: "col-lg-8" }
const _hoisted_33 = { class: "fv-plugins-message-container" }
const _hoisted_34 = { class: "fv-help-block" }
const _hoisted_35 = { class: "col-md-6 fv-row" }
const _hoisted_36 = { class: "col-lg-12 col-form-label required fw-bold fs-6" }
const _hoisted_37 = ["title"]
const _hoisted_38 = { class: "col-lg-8 fv-row" }
const _hoisted_39 = { class: "fv-plugins-message-container" }
const _hoisted_40 = { class: "fv-help-block" }
const _hoisted_41 = { class: "row mb-5" }
const _hoisted_42 = { class: "col-md-6 fv-row" }
const _hoisted_43 = { class: "col-lg-12 col-form-label required fw-bold fs-6" }
const _hoisted_44 = ["title"]
const _hoisted_45 = { class: "col-lg-10 fv-row" }
const _hoisted_46 = { class: "fv-plugins-message-container" }
const _hoisted_47 = { class: "fv-help-block" }
const _hoisted_48 = { class: "col-md-6 fv-row" }
const _hoisted_49 = { class: "col-lg-12 col-form-label required fw-bold fs-6" }
const _hoisted_50 = ["title"]
const _hoisted_51 = { class: "col-lg-12 fv-row" }
const _hoisted_52 = { class: "fv-plugins-message-container" }
const _hoisted_53 = { class: "fv-help-block" }
const _hoisted_54 = {
  key: 0,
  class: "card-footer d-flex justify-content-end py-6 px-9"
}
const _hoisted_55 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_56 = { class: "indicator-label" }
const _hoisted_57 = { class: "indicator-progress" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('create', 'instant-rent-estimator'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('createNewIreArea')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitCreate,
            "validation-schema": _ctx.ireAreaSchema
          }, {
            default: _withCtx(({ values }) => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.translate('areas')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.selectedArea,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedArea) = $event)),
                      requierd: true,
                      label: "titleAr",
                      trackBy: "titleAr",
                      searchable: true,
                      canDeselect: false,
                      options: _ctx.areas,
                      placeholder: _ctx.translate('selectAreas'),
                      valueProp: "id",
                      noResultsText: _ctx.translate('noResultsFound')
                    }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.translate('baseValue')), 1),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "baseValue",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('baseValue')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_ErrorMessage, { name: "baseValue" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.translate('isSeaView')) + ": ", 1),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("label", _hoisted_18, [
                      _createVNode(_component_Field, {
                        class: "form-check-input",
                        name: "isSeaView",
                        type: "checkbox",
                        value: true,
                        checked: "checked"
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.translate('sort')), 1),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "sort",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('sort'),
                      "onUpdate:modelValue": ($event: any) => (values.sort = Number(values.sort))
                    }, null, 8, ["placeholder", "onUpdate:modelValue"]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_ErrorMessage, { name: "sort" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.translate('customUpdatedAt')) + ": ", 1),
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_Field, {
                      type: "date",
                      name: "customUpdatedAt",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid"
                    })
                  ])
                ]),
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("label", _hoisted_30, [
                      _createTextVNode(_toDisplayString(_ctx.translate('firstIncreasePercentage')) + " ", 1),
                      _createElementVNode("i", {
                        class: "fas fa-exclamation-circle ms-1 fs-7 bg-hover-white",
                        "data-bs-toggle": "tooltip",
                        title: _ctx.translate('firstIncreasePercentageToolTip')
                      }, null, 8, _hoisted_31)
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "firstIncreasePercentage",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-white",
                        placeholder: _ctx.translate('firstIncreasePercentage')
                      }, null, 8, ["placeholder"]),
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createVNode(_component_ErrorMessage, { name: "firstIncreasePercentage" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("label", _hoisted_36, [
                      _createTextVNode(_toDisplayString(_ctx.translate('secondIncreasePercentage')) + " ", 1),
                      _createElementVNode("i", {
                        class: "fas fa-exclamation-circle ms-1 fs-7 bg-hover-white",
                        "data-bs-toggle": "tooltip",
                        title: _ctx.translate('secondIncreasePercentageToolTip')
                      }, null, 8, _hoisted_37)
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "secondIncreasePercentage",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-white",
                        placeholder: _ctx.translate('secondIncreasePercentage')
                      }, null, 8, ["placeholder"]),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _createVNode(_component_ErrorMessage, { name: "secondIncreasePercentage" })
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("label", _hoisted_43, [
                      _createTextVNode(_toDisplayString(_ctx.translate('firstDecreasedPercentage')) + " ", 1),
                      _createElementVNode("i", {
                        class: "fas fa-exclamation-circle ms-1 fs-7 bg-hover-white",
                        "data-bs-toggle": "tooltip",
                        title: _ctx.translate('firstDecreasedPercentageToolTip')
                      }, null, 8, _hoisted_44)
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "firstDecreasedPercentage",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-white",
                        placeholder: _ctx.translate('firstDecreasedPercentage')
                      }, null, 8, ["placeholder"]),
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          _createVNode(_component_ErrorMessage, { name: "firstDecreasedPercentage" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("label", _hoisted_49, [
                      _createTextVNode(_toDisplayString(_ctx.translate('secondDecreasedPercentage')) + " ", 1),
                      _createElementVNode("i", {
                        class: "fas fa-exclamation-circle ms-1 fs-7 bg-hover-white",
                        "data-bs-toggle": "tooltip",
                        title: _ctx.translate('secondDecreasedPercentageToolTip')
                      }, null, 8, _hoisted_50)
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "secondDecreasedPercentage",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-white",
                        placeholder: _ctx.translate('secondDecreasedPercentage')
                      }, null, 8, ["placeholder"]),
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, [
                          _createVNode(_component_ErrorMessage, { name: "secondDecreasedPercentage" })
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              (!_ctx.createdArea)
                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                    _createElementVNode("button", {
                      type: "reset",
                      class: "btn btn-white btn-active-light-primary me-2",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                    }, _toDisplayString(_ctx.translate('discard')), 1),
                    _createElementVNode("button", _hoisted_55, [
                      _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.translate('saveChanges')), 1),
                      _createElementVNode("span", _hoisted_57, [
                        _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                        _hoisted_58
                      ])
                    ], 512)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}